import React, { useEffect, useState } from 'react'
import Modal from 'meinian-package/src/baseComponent/modal'
import Button from 'meinian-package/src/baseComponent/button'
import { request } from 'meinian-package/src/utils'
import globalData from 'meinian-package/src/common/globalData'
import classNames from 'classnames'
import { CommonInspirationBaseCard } from '../commonInspiration'
import { ShareType } from '../../intellectRecommend/recommendCard/inspiration/shareType'
import styles from './index.module.less'

export default () => {
  const _key = 'workbench-official-inspiration'
  const [visible, setVisible] = useState(0)
  const [exclusiveData, setExclusiveData] = useState([])
  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = () => {
    request.get('/zhikuan/mn/recommend/list-daily-recommend').then((res:any) => {
      res.length && globalData.get(_key, setVisible, 1)
      setExclusiveData(res)
    })
  }
  const onClose = () => {
    setVisible(0)
    globalData.set(_key, 0)
  }
  return <Modal
    visible={!!visible}
    footer={false}
    style={{ width: 640, height: 430 }}
    hiddenCloseIcon={false}
    hiddenFooter
    onClose={onClose}
  >
    <ModalContent
      onClose={onClose}
      exclusiveData={exclusiveData}
    />
  </Modal>
}

const ModalContent = ({ exclusiveData, onClose }) => {
  const [data, setData] = useState([])
  const defaultParams = {
    rankStatus: 2,
    start: 0,
    pageSize: 20,
  }

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = () => {
    request.post('/zhikuan/ins/inspiration/list-inspiration-style', defaultParams).then((res:any) => {
      setData(res.resultList)
    })
  }
  const curExclusive = exclusiveData?.[0]
  return <div className={styles.officialInspirationModal}>
    <div className={styles.officialInspirationList}>
      <div className={styles.title}>近期热门官方灵感集</div>
      <div className={styles.options}>
        {
          data.slice(0, 5).map(item => <CommonInspirationBaseCard
            itemData={item}
            imgStyle={{ width: '48px', height: '48px' }}
            className={classNames(styles.item, 'fill-grey-bg', 'cursor-pointer')}
            onClick={() => {
              window.open(`/meinian/home/coll/detail/${item.shareUrl}?shareUrl=${item.shareUrl}&shareType=${ShareType.OFFICIAL}`)
            }}
          />)
        }
      </div>
    </div>
    <div className={styles.officialInspirationExclusive}>
      <div>
        <div className={styles.title}>根据你的选款记录，<br />已为你生成专属灵感集</div>
        <div className={styles.title2}>
          *根据你的采集、图搜数据生成，你的采集和图搜的频率越高，更新频率也会加快
        </div>
        <CommonInspirationBaseCard
          className={classNames('fill-white-bg', 'cursor-pointer')}
          itemData={{
            coverImgUrl: curExclusive.imageUrl,
            name: curExclusive.dailyName,
            ...curExclusive
          }}
          style={{
            width: 308,
            marginTop: '16px',
            border: '1px solid var(--m-fill-4)',
          }}
          onClick={() => {
            window.open(`/meinian/home/coll/exclusive-detail?id=${curExclusive.blogId}&name=${curExclusive.dailyName}`)
          }}
        />
      </div>
      <Button
        type="primary"
        className={styles.closedBtn}
        onClick={() => {
          window.open(`/meinian/home/coll/exclusive-detail?id=${curExclusive.blogId}&name=${curExclusive.dailyName}`)
          onClose()
        }}
      >立即查收</Button>
    </div>
  </div>
}
